import { ThunkType } from 'app/hooks/appHooks';
import { setLocation } from 'app/store/thunk/location/setLocationThunk';
import { updateLocationSearch } from 'app/functions/environment';
import { mapCityDetailResponse } from 'app/functions';
import { CitiesDetailsResponseCity } from '@webc/meeseeks-ui-sdk';

export type UpdateLocationsType = {
  fromCityDetails: CitiesDetailsResponseCity;
  toCityDetails: CitiesDetailsResponseCity;
};

export const updateLocations =
  ({ fromCityDetails, toCityDetails }: UpdateLocationsType): ThunkType<void> =>
  (dispatch) => {
    const urlParams = new URLSearchParams(window.location.search);

    // do not update search mask locations if user is searching for a return trip
    if (!urlParams.get('backRide')) {
      dispatch(
        setLocation({ direction: 'from', location: mapCityDetailResponse(fromCityDetails) }),
      );
      dispatch(setLocation({ direction: 'to', location: mapCityDetailResponse(toCityDetails) }));
    }
    const DEPARTURE_CITY = 'departureCity';
    const ARRIVAL_CITY = 'arrivalCity';
    urlParams.set(DEPARTURE_CITY, fromCityDetails.id);
    urlParams.set(ARRIVAL_CITY, toCityDetails.id);

    updateLocationSearch(urlParams);
  };
